import { type RouteObject } from 'react-router-dom';

export const giftRoute: RouteObject = {
  path: 'gifts',
  children: [
    {
      path: '',
      lazy: () => import('./gifts'),
    },
  ],
};
